import { z } from "zod";
import { normalizeRelativePath } from "../domain/paths";

export const TRASH_METADATA_FILE = ".shotboard_trash.json";

export const trashMetadataSchema = z.object({
  format: z.literal("shotboard-trash-entry"),
  schemaVersion: z.literal(1),
  originalPath: z.array(z.string().min(1)).min(1),
  trashedAt: z.iso.datetime(),
});

export type TrashMetadata = z.infer<typeof trashMetadataSchema>;

/** Parses portable trash metadata while rejecting path traversal. */
export function parseTrashMetadata(raw: string): TrashMetadata {
  const metadata = trashMetadataSchema.parse(JSON.parse(raw));
  normalizeRelativePath(metadata.originalPath);
  return metadata;
}

/** Serializes one validated trash record for placement beside the trashed board. */
export function serializeTrashMetadata(metadata: TrashMetadata): string {
  return `${JSON.stringify(trashMetadataSchema.parse(metadata), null, 2)}\n`;
}
